import React, { useState } from "react";
import {
    SaveButton, DeleteButton, Toolbar,
    useRecordContext, useResourceContext,
    useNotify, useDataProvider, useRefresh, useRedirect,    Confirm
} from "react-admin";
import alasql from "alasql";
import {
    Dialog, DialogActions, DialogContent,
    DialogTitle, Button, MenuItem, TextField
} from "@mui/material";
import { useFormContext } from "react-hook-form";

const styles = {
    buttonSpacing: { margin: '5px' },
    buttonContainer: { display: 'flex', flexWrap: 'wrap', gap: '10px' }
};

const ECreateToolbar = ({ initValues, ...props }) => {
    const record = useRecordContext() || {};
    const resource = useResourceContext();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const mergedRecord = { ...record, ...initValues };

    const role = localStorage.getItem("role");
    let resourcePermissions = alasql(`SELECT * FROM resource_permistions WHERE resource_name = "${resource}" AND ${role}_delete = true`);
    let canDelete = resourcePermissions.length > 0;

    // 1) Query: fetch init_values and the 'delete' permission for the given role
const rows = alasql(`
    SELECT init_values
    FROM resource_permistions 
    WHERE resource_name = "${resource}"
`);

// 2) Initialize default values
let disableSave = false;

if (rows.length > 0) {
    const { init_values: initValuesRaw} = rows[0];

    // Check if we can delete

    // If init_values is not empty, parse it as JSON
    if (initValuesRaw) {
        try {
            // Validate that initValuesRaw is a string and not empty
            if (typeof initValuesRaw !== 'string' || initValuesRaw.trim() === '') {
                console.warn('init_values is not a valid string:', initValuesRaw);
            } else {
                const initValues = JSON.parse(initValuesRaw);
                // If parsed successfully, check if 'disableSave' is defined
                if (
                    initValues && 
                    typeof initValues === 'object' && 
                    initValues.hasOwnProperty('disableSave')
                ) {
                    disableSave = initValues.disableSave;
                }
            }
        } catch (err) {
            console.error('Error parsing init_values JSON for resource:', resource);
            console.error('Raw init_values content:', initValuesRaw);
            console.error('JSON Parse Error:', err.message);
            // Continue with default disableSave = false
        }
    }
}


    


    var Hooks = [];
    var workflow = 'none';
    let actions = [];

    if (mergedRecord) {
        let stc = alasql(`SELECT DISTINCT StateColumn AS col FROM workflows WHERE Module = '${resource}' AND role_${role} = 'control'`).map(({ col }) => col);
        if (stc?.[0]) {
            actions = alasql(`SELECT * FROM workflows WHERE Module = '${resource}' AND role_${role} = 'control' AND StateColumn = '${stc[0]}' AND StateValue = '${mergedRecord[stc[0]]}'`);
            if (actions?.[0] && actions?.[0]?.Actions && actions?.[0]?.Actions !== '[]') {
                try {
                    // Parse the Actions JSON string before using in ALASQL query
                    const actionsArray = JSON.parse(actions[0].Actions);
                    const actionsArrayString = JSON.stringify(actionsArray);
                    Hooks = alasql(`SELECT * FROM workflows WHERE Module = '${resource}' AND role_${role} = 'control' AND WorkFlowName = ANY (ARRAY${actionsArrayString})`);
                    workflow = actions[0].WorkFlowName;
                } catch (err) {
                    console.error('Error parsing Actions JSON in workflow:', err);
                    console.error('Raw Actions content:', actions[0].Actions);
                    // Continue with empty Hooks array
                }
            }
        }
    }

    // Dialog State for rejection
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [open, setOpen] = useState(false);

    // Dialog State for delete
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedDeleteReason, setSelectedDeleteReason] = useState("");
    const [otherDeleteReason, setOtherDeleteReason] = useState("");
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);

            const handleClick = () => setOpen(true);



    const handleRejectSave = (hook) => {
        setOpenDialog(true);
    };

    const handleDialogConfirmClose = async (hook) => {
    // close both overlays first
    setOpenDialog(false);
    setOpen(false);

    /* …then run the update logic … */
};


    const handleDialogConfirm = async (hook) => {
        if (!selectedReason) {
            notify("يرجى اختيار سبب الرفض", { type: "warning" });
            return;
        }

        if (selectedReason === "أخرى" && !otherReason.trim()) {
            notify("يرجى إدخال سبب الرفض في حال اختيار 'أخرى'", { type: "warning" });
            return;
        }

        setValue(hook.StateColumn, hook.StateValue); // Force update form field
        setValue("rejection_reason", selectedReason); // Force update form field
        setValue("rejection_details", selectedReason === "أخرى" ? otherReason : null); // Force update form field
        setValue("last_action", hook.title); // Force update form field

        const updatedData = {
            ...mergedRecord,
            [hook.StateColumn]: hook.StateValue,
            rejection_reason: selectedReason,
            rejection_details: selectedReason === "أخرى" ? otherReason : null,
            last_action: hook.title
        };

        try {
            await dataProvider.update(resource, {
                id: mergedRecord.id,
                data: updatedData,
            });

            notify("تم رفض البلاغ بنجاح", { type: "success" });
            refresh();
            redirect("list", resource);
        } catch (error) {
            notify("حدث خطأ أثناء الحفظ", { type: "error" });
        }

        setOpenDialog(false);
                setOpen(false);      // open the second-step confirm

    };

    const handleAcceptSave = async (hook) => {
        const updatedData = {
            ...mergedRecord,
            [hook.StateColumn]: hook.StateValue,
            rejection_reason: null,
            rejection_details: null,
            last_action: hook.title
        };

        try {
            await dataProvider.update(resource, {
                id: mergedRecord.id,
                data: updatedData,
                previousData: mergedRecord
            });

            notify("تم الاعتماد  بنجاح", { type: "success" });
            refresh();
            redirect("list", resource);
        } catch (error) {
            notify("حدث خطأ أثناء الحفظ", { type: "error" });
        }
    };

    const [currentDeleteHook, setCurrentDeleteHook] = useState(null);

    const handleDeleteSave = (hook) => {
        setCurrentDeleteHook(hook);
        setOpenDeleteDialog(true);
    };

    const handleDeleteDialogConfirmClose = () => {
        setOpenDeleteDialog(false);
        setOpenDeleteConfirm(false);
    };

    const handleDeleteDialogConfirm = async () => {
        const hook = currentDeleteHook;
        if (!selectedDeleteReason) {
            notify("يرجى اختيار سبب الحذف", { type: "warning" });
            return;
        }
        if (selectedDeleteReason === "أخرى" && !otherDeleteReason.trim()) {
            notify("يرجى إدخال سبب الحذف في حال اختيار 'أخرى'", { type: "warning" });
            return;
        }

        setValue(hook.StateColumn, hook.StateValue);
        setValue("rejection_reason", selectedDeleteReason);
        setValue("rejection_details", selectedDeleteReason === "أخرى" ? otherDeleteReason : null);
        setValue("last_action", hook.title);

        const updatedData = {
            ...mergedRecord,
            [hook.StateColumn]: hook.StateValue,
            rejection_reason: selectedDeleteReason,
            rejection_details: selectedDeleteReason === "أخرى" ? otherDeleteReason : null,
            last_action: hook.title
        };

        try {
            await dataProvider.update(resource, {
                id: mergedRecord.id,
                data: updatedData,
            });
            notify("تم الحذف بنجاح", { type: "success" });
            refresh();
            redirect("list", resource);
        } catch (error) {
            notify("حدث خطأ أثناء الحفظ", { type: "error" });
        }

        setOpenDeleteDialog(false);
        setOpenDeleteConfirm(false);
    };

// ES2018+ (all modern browsers & Node≥10) 
const isDigitsOnly = (s) => /^\p{N}+$/u.test(s.trim());


    const { setValue } = useFormContext();

    return (
        <Toolbar {...props}>
            <div style={styles.buttonContainer}>
                {/* Main Save Button with type="button" */}
                {disableSave==false && <SaveButton
                    type="button" // Prevent default form submission
                    redirect="list"
                    alwaysEnable
                    style={styles.buttonSpacing}
                />}

                {/* Workflow Buttons */}
                {Hooks.map((hook, index) => (
                    hook.type === "reject" ? (
                        <Button
                            key={index}
                            variant="contained"
                            color="secondary"
                            onClick={() => handleRejectSave(hook)}
                            style={styles.buttonSpacing}
                        >
                            {hook.title}
                        </Button>
                    ) : hook.type === "delete" ? (
                        <Button
                            key={index}
                              variant="contained"
                            color="error"
                            onClick={() => handleDeleteSave(hook)}
                            style={styles.buttonSpacing}
                        >
                            {hook.title}
                        </Button>
                    ) : hook.type === "accept" ? (
                        <SaveButton
                            key={index}
                            type="button" // Prevent form submission
                            redirect="list"
                            alwaysEnable
                            label={hook.title}
                              onClick={(e) => {
    if (!window.confirm(`هل أنت متأكد من أنك تريد ${hook.title} هذا البلاغ؟`)) {
      e.preventDefault();
      e.stopPropagation();
      return; // cancel
    }



                                setValue(hook.StateColumn, hook.StateValue); // Force update form field
                                setValue("rejection_reason", null); // Force update form field
                                setValue("rejection_details", null); // Force update form field
                                setValue("last_action", hook.title); // Force update form field
                            }}
                            transform={data => {
                                const transformedData = {
                                  ...data,
                                  [hook.StateColumn]: hook.StateValue,
                                  rejection_reason: null,
                                  rejection_details: null,
                                  last_action: hook.title
                                };
                                return transformedData;
                              }}
                            style={styles.buttonSpacing}
                        />
                    ) : hook.type === "accept_without_confirm" ? (
                        <SaveButton
                            key={index}
                            type="button"
                            redirect="list"
                            alwaysEnable
                            label={hook.title}
                            onClick={async (e) => {
                                // Validate form BEFORE submission
                                const isValid = await trigger();
                                if (!isValid) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    notify('الرجاء تعبئة جميع الحقول المطلوبة', { type: 'error' });
                                    return; // Stop if validation fails
                                }

                                setValue(hook.StateColumn, hook.StateValue);
                                setValue("rejection_reason", null);
                                setValue("rejection_details", null);
                                setValue("last_action", hook.title);
                            }}
                            transform={data => {
                                const transformedData = {
                                    ...data,
                                    [hook.StateColumn]: hook.StateValue,
                                    rejection_reason: null,
                                    rejection_details: null,
                                    last_action: hook.title
                                };
                                return transformedData;
                            }}
                            style={styles.buttonSpacing}
                        />
                    ) : (
                        <SaveButton
                            key={index}
                            type="button" // Prevent form submission
                            redirect="list"
                            alwaysEnable
                            label={hook.title}
                            transform={data => ({
                                ...data,
                                [hook.StateColumn]: hook.StateValue
                            })}
                            style={styles.buttonSpacing}
                        />
                    )
                ))}

                {/* Delete Button (if permitted) */}
                {canDelete && <DeleteButton {...props} style={styles.buttonSpacing} />}
            </div>

            {/* Rejection Dialog */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>رفض البلاغ</DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        fullWidth
                        label="سبب الرفض"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                        margin="normal"
                    >
                        <MenuItem value="بيانات ناقصة">بيانات ناقصة</MenuItem>
                        <MenuItem value="بيانات خاطئة">بيانات خاطئة</MenuItem>
                        <MenuItem value="أخرى">أخرى</MenuItem>
                    </TextField>

                    {selectedReason === "أخرى" && (
                        <TextField
                            fullWidth
                            label="أدخل سبب الرفض"
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            margin="normal"
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">إلغاء</Button>

                     <Confirm
                isOpen={open}
                title={` تأكيد الرفض`}
                content="هل أنت متأكد من أنك تريد رفض هذا البلاغ؟"
                confirmText="نعم"
                confirmButtonLabel="تأكيد"
                onConfirm={() => handleDialogConfirm(Hooks.find(h => h.type === "reject"))}
                onClose={() => handleDialogConfirmClose()}
                confirmColor="secondary"
            />



<Button
    onClick={() => {
        // validate first
        if (!selectedReason) {
            notify("يرجى اختيار سبب الرفض", { type: "warning" });
            return;
        }
if (selectedReason === "أخرى") {
    if (!otherReason.trim()) {
        notify("يرجى إدخال سبب الرفض في حال اختيار 'أخرى'", { type: "warning" });
        return;
    }
    if (isDigitsOnly(otherReason)) {
        notify("سبب الرفض يجب أن يحتوي على حروف وليس أرقام فقط", { type: "warning" });
        return;
    }
}

        setOpen(true);      // open the second-step confirm
    }}
    color="secondary"
>
    تأكيد الرفض
</Button>
                </DialogActions>
            </Dialog>
            {/* Delete Dialog */}
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>حذف السجل</DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        fullWidth
                        label="سبب الحذف"
                        value={selectedDeleteReason}
                        onChange={(e) => setSelectedDeleteReason(e.target.value)}
                        margin="normal"
                    >
                        <MenuItem value="بلاغ مكرر">بلاغ مكرر</MenuItem>
                        <MenuItem value="المدرسة غير مخدومة">المدرسة غير مخدومة</MenuItem>
                        <MenuItem value="خارج نطاق الاختصاص">خارج نطاق الاختصاص</MenuItem>
                        <MenuItem value="إلغاء من قبل المبلّغ">إلغاء من قبل المبلّغ</MenuItem>
                        <MenuItem value="عدم وقوع الحادث فعليّا">عدم وقوع الحادث فعليّا</MenuItem>
                        <MenuItem value="عدم الاستجابة من المبلّغ">عدم الاستجابة من المبلّغ</MenuItem>
                        <MenuItem value="تحويل البلاغ لجهة أخرى">تحويل البلاغ لجهة أخرى</MenuItem>
                        <MenuItem value="بلاغ كيدي أو مضلل">بلاغ كيدي أو مضلل</MenuItem>
                        <MenuItem value="أخرى">أخرى</MenuItem>
                    </TextField>
                    {selectedDeleteReason === "أخرى" && (
                        <TextField
                            fullWidth
                            label="أدخل سبب الحذف"
                            value={otherDeleteReason}
                            onChange={(e) => setOtherDeleteReason(e.target.value)}
                            margin="normal"
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary">إلغاء</Button>
                    <Confirm
                        isOpen={openDeleteConfirm}
                        title="تأكيد الحذف"
                        content="هل أنت متأكد من أنك تريد حذف هذا السجل؟"
                        confirmText="نعم"
                        confirmButtonLabel="تأكيد"
                        onConfirm={handleDeleteDialogConfirm}
                        onClose={handleDeleteDialogConfirmClose}
                        confirmColor="secondary"
                    />
                    <Button
                        onClick={() => {
                            if (!selectedDeleteReason) {
                                notify("يرجى اختيار سبب الحذف", { type: "warning" });
                                return;
                            }
                            if (selectedDeleteReason === "أخرى") {
                                if (!otherDeleteReason.trim()) {
                                    notify("يرجى إدخال سبب الحذف في حال اختيار 'أخرى'", { type: "warning" });
                                    return;
                                }
                                if (isDigitsOnly(otherDeleteReason)) {
                                    notify("سبب الحذف يجب أن يحتوي على حروف وليس أرقام فقط", { type: "warning" });
                                    return;
                                }
                            }
                            setOpenDeleteConfirm(true);
                        }}
                        color="secondary"
                    >
                        تأكيد الحذف
                    </Button>
                </DialogActions>
            </Dialog>
        </Toolbar>
    );
};

export default ECreateToolbar;
